import { roles } from "./roles";

export const SELF_PACED_ROLES = [
  {
    id: 1,
    name: "Self Paced Scrum Master",
    value: "self_paced_scrum_master",
    path_id: 104442,
  },
  {
    id: 2,
    name: "Self Paced AI Product Owner",
    value: "self_paced_product_owner",
    path_id: 317153,
  },
  {
    id: 3,
    name: "Self Paced Business Analyst",
    value: "self_paced_business_analyst",
    path_id: 99221,
  },
  {
    id: 4,
    name: "Self Paced Product Manager",
    value: "self_paced_product_manager",
    path_id: 99486,
  },
  {
    id: 5,
    name: "Self Paced Agile Project Manager",
    value: "self_paced_agile_project_manager",
    path_id: 99486,
  },

  {
    id: 6,
    name: "ICP Certification Only",
    value: "aa_icp_certification",
    path_id: 329807,
  },

  {
    id: 6,
    name: "PDM Certification Only",
    value: "aa_icp_pdm_certification",
    path_id: 329808,
  },
];

export const FREE_SELF_PACED_ROLES = [
  {
    id: 1,
    name: "Free Self Paced Business Analyst",
    value: roles.FREE_SELF_PACED_BUSINESS_ANALYST_STUDENT,
    path_id: 299114,
  },
  {
    id: 2,
    name: "Free Self Paced Product Owner",
    value: roles.FREE_SELF_PACED_PRODUCT_OWNER_STUDENT,
    path_id: 299116,
  },
];
